import React, { Component } from 'react';
import _ from 'lodash';
import Image from '../../../../../components/ZUILib/Image';
import { errorStrings } from '../../../../../utils/errorStrings';
import commonUtil from '../../../../../utils/commonUtil';


const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();

class Intransit extends Component {
  render() {
    const intransitRow = function (data, index) {
      const getIntransitImg = [
        {
          media: '(max-width: 465px)',
          srcSet: data.image,
        },
      ];
      const getIntransitImage = {
        src: data.image,
        altImg: commonUtil.getAssetURL() + '/images/guest/gift.png',
        width: 'auto',
        height: 'auto',
        className: 'img-responsive',

      };

      return (
        channel === constChannels.WEB ?
          <tr key={index}>
            <td className="dat">{data.date}</td>
            <td>
              <div className="imageGift"> <Image imageAttr={getIntransitImage} _imgsrc={getIntransitImg} /></div>
            </td>
            <td className="articulo">
              <p>{data.productName}</p>
              <p>{data.skuId}</p>
            </td>
            <td className="cant text-center">{data.quantity}</td>
            <td className="storeSate text-center">{data.brand}</td>
            <td className="rode">{commonUtil.getCurrency(data.amount)}</td>
          </tr>
          :
          <div key={index} className="row mt-5 gadgetInfoArticle m-l-0 m-r-0">
            <div className="col-xs-12 inner shadowSquare">
              <div className="row head">
                <div className="col-xs-12">
                  <p>Fecha de compra:<span className="date">{data.date}</span></p>
                </div>
              </div>
              <div className="row content m-l-0 m-r-0">
                <div className="col-xs-4"><Image imageAttr={getIntransitImage} _imgsrc={getIntransitImg} /></div>
                <div className="col-xs-8">
                  <p className="titleArticle">{data.productName}</p>
                  <p className="sku">{data.skuId}</p>
                  <p className="price">{commonUtil.getCurrency(data.amount)}</p>
                  <p className="quantity">Cantidad: {data.quantity}</p>
                  <p className="store">Tienda: {data.brand}</p>
                </div>
              </div>
            </div>
          </div>
      );
    };

    return (
      <div className={channel === constChannels.WEB ? 'row' : null}>
        {
          channel === constChannels.WEB ?
            <div className="col-md-12">
              <table className="cTable bottomLine infoListGifts">
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th className="imageGift">&nbsp;</th>
                    <th>Artículo</th>
                    <th className="text-center">Cantidad</th>
                    <th className="text-center">Tienda</th>
                    <th>Monto</th>
                  </tr>
                </thead>
                <tbody className="text-left">
                  {!_.isEmpty(this.props.inTransitInfoData.inTransitInfo) ? this.props.inTransitInfoData.inTransitInfo.map(intransitRow) : <tr><td>{errorStrings.noRecordsFound}</td></tr>}
                </tbody>
              </table>
            </div>
            :
            <div>
              {!_.isEmpty(this.props.inTransitInfoData.inTransitInfo) ? this.props.inTransitInfoData.inTransitInfo.map(intransitRow) : errorStrings.noRecordsFound}
            </div>
        }
      </div>
    );
  }
}
export default Intransit;
